<template>
  <div class="page_evidence">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
          <!-- <el-form-item label="存证编号">
            <el-input v-model="listQuery.evidenceNo" placeholder="请输入存证编号" clearable style="width:180px"></el-input>
          </el-form-item> -->
          <el-form-item label="项目">
            <el-select v-model="listQuery.projectId" placeholder="请选择项目" clearable filterable style="width:180px">
              <el-option v-for="item in projectList" :key="item.Projectid" :label="item.StrprojectName" :value="item.Projectid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据类型">
            <el-select v-model="listQuery.dataType" placeholder="请选择数据类型" clearable filterable style="width:180px">
              <el-option v-for="(item, index) in dataTypeList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计周期">
            <el-date-picker v-model="listQuery.cycle" style="width:180px" type="month" value-format="yyyy-MM"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="起止日期">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width:260px"
              @change="onDateRangeChange">
            </el-date-picker>
          </el-form-item> -->
        </el-form>
      </div>

      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>区块链</el-breadcrumb-item>
          <el-breadcrumb-item>存证管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="总览看板" name="0"></el-tab-pane>
          <el-tab-pane label="上链任务管理" name="1"></el-tab-pane>
          <el-tab-pane label="存证查询与验证" name="2"></el-tab-pane>
          <!-- <el-tab-pane label="证据出具" name="3"></el-tab-pane> -->
          <el-tab-pane label="系统管理" name="4"></el-tab-pane>
        </el-tabs>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column type="selection" width="48" align="center"></el-table-column>
          <el-table-column prop="companyName" label="公司主体" min-width="240" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" min-width="140" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="dataType" label="数据类型" min-width="100" align="center">
            <template slot-scope="{row}">
              {{ getDataTypeLabel(row.dataType) }}
            </template>
          </el-table-column>
          <el-table-column prop="cycle" label="统计周期" min-width="120" align="center"></el-table-column>
          <!-- <el-table-column prop="hash" label="哈希值" min-width="200" align="center" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span class="hash_value" :title="row.hash">{{ formatHash(row.hash) }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="chainTime" label="上链时间" min-width="170" align="center">
            <template slot-scope="{row}">{{ formatTime(row.createTime) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center" fixed="right">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="verifyHandle(row)">验证</el-button>
                <el-button type="text" size="small" @click="detailHandle(row)">详情</el-button>
                <!-- <el-button type="text" size="small" @click="evidenceHandle(row)">出证</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block evidence_pagination">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageModel.page" :page-size="Number(listQuery.pageModel.rows)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 验证弹窗（合并验证/详情/证据出具） -->
    <el-dialog :visible.sync="verifyVisible" width="560px" class="verify_result_dialog" custom-class="verify_result_box" :show-close="true">
      <div class="verify_result">
        <div class="verify_result_head">
          <div class="verify_icon"><i class="el-icon-check"></i></div>
          <div class="verify_title">哈希匹配 验证通过</div>
        </div>
        <div class="verify_actions">
          <el-button class="verify_action_btn" :disabled="!currentRow" @click="downloadCertificate(currentRow)">下载存证证明</el-button>
          <el-button class="verify_action_btn" :disabled="!currentRow" @click="detailHandle(currentRow)">查看原始数据</el-button>
          <el-button class="verify_action_btn" :disabled="!currentRow" @click="evidenceHandle(currentRow)">申请司法出证</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog title="存证详情" :visible.sync="detailVisible" width="550px" class="res_dialog">
      <el-form :model="detailForm" label-width="110px" size="small" class="detail_form">
        <el-form-item label="存证编号">
          <span>{{ detailForm.chainId }}</span>
        </el-form-item>
        <el-form-item label="数据类型">
          <span>{{ getDataTypeLabel(detailForm.dataType) }}</span>
        </el-form-item>
        <el-form-item label="公司主体">
          <span>{{ detailForm.companyName }}</span>
        </el-form-item>
        <el-form-item label="项目名称">
          <span>{{ detailForm.projectName }}</span>
        </el-form-item>
        <el-form-item label="统计周期">
          <span>{{ detailForm.cycle }}</span>
        </el-form-item>
        <!-- <el-form-item label="哈希值">
          <span class="hash_full">{{ detailForm.hash }}</span>
        </el-form-item> -->
        <el-form-item label="上链时间">
          <span>{{ formatTime(detailForm.createTime) }}</span>
        </el-form-item>
        <el-form-item label="区块高度">
          <!-- <span>{{ detailForm.blockHeight }}</span> -->
        </el-form-item>
        <!-- <el-form-item label="存证数据">
          <pre class="evidence_data">{{ detailForm.recordCount }}</pre>
        </el-form-item> -->
        <el-form-item label="原始数据">
          <el-button type="text" class="download_raw_btn" :disabled="!detailForm.rawData" @click="toDownFile(imgHead + detailForm.rawData)">
            <i class="el-icon-document"></i>
            <span>下载原始数据</span>
          </el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 出证图片预览弹窗 -->
    <el-dialog title="证据出具" :visible.sync="evidenceImgVisible" width="680px" class="res_dialog" append-to-body @close="clearEvidenceBlob">
      <div style="text-align:center;">
        <iframe :src="evidenceImgUrl" v-if="evidenceImgUrl" style="width:100%;height:500px;border:none;"></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="downloadEvidencePdf">下载</el-button>
        <el-button size="small" @click="evidenceImgVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        loading: false,
        verifyLoading: false,
        tableData: [],
        totalCount: 0,
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [{
              property: "updataTime",
              order: 1
            }]
          },
          busiStat: '2',
          projectId: null,
          dataType: '',
          startDate: '',
          endDate: ''
        },
        activeName: '2',
        projectList: [],
        dataTypeList: [
          "录用通知",
          "排班记录",
          "接受排班",
          "任务派发记录",
          "接受任务",
          "考勤签到签退（含定位）",
          "考勤确认",
          "薪资确认",
          "验收单据",
          "结算资料",
          "付款凭证"
        ],
        verifyVisible: false,
        verifyForm: {},
        currentRow: null,
        detailVisible: false,
        detailForm: {},
        evidenceImgVisible: false,
        evidenceImgUrl: '',
        evidenceBlobUrl: '',
        imgHead: this.$store.state.EMP.imgPath,
        dateRange: []
      }
    },
    created() {
      this.getProList();
      this.getList();
    },
    methods: {
      changeTab() {
        if (this.activeName === '2') {
          this.getList();
        } else if (this.activeName == '0' || this.activeName == '1') {
          this.$router.push({
            path: '/onChainManage',
            query: {
              activeName: this.activeName
            }
          })
        }
      },
      //获取项目
      getProList() {
        let data = {
          roletype: localStorage.loginRoletype,
          projectname: "",
          perpage: 10000,
          currpage: 1,
        };
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      getList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetBlockChainPageList').then(res => {
          if (res.status === 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.error(res.msg || '获取数据失败');
          }
          this.loading = false;
        }).catch(error => {
          console.error('Error fetching evidence list:', error);
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      resetHandle() {
        this.listQuery.evidenceNo = '';
        this.listQuery.projectId = null;
        this.listQuery.dataType = '';
        this.listQuery.startDate = '';
        this.listQuery.endDate = '';
        this.dateRange = [];
        this.searchHandle();
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      getDataTypeLabel(val) {
        return val || '-';
      },
      onDateRangeChange(val) {
        if (val && val.length === 2) {
          this.listQuery.startDate = val[0];
          this.listQuery.endDate = val[1];
        } else {
          this.listQuery.startDate = '';
          this.listQuery.endDate = '';
        }
      },
      toDownFile(url) {
        window.open(url);
      },
      formatHash(val) {
        if (!val) return '-';
        if (val.length > 14) {
          return val.substring(0, 10) + '...' + val.substring(val.length - 4);
        }
        return val;
      },
      formatTime(val) {
        if (!val) return '-';
        if (typeof val === 'string' && val.indexOf('T') > -1) {
          return val.replace('T', ' ');
        }
        return val;
      },
      verifyHandle(row) {
        this.currentRow = row;
        // let str = `?Ids=${row.id}`
        // xz.ArdCurStatGetFun('EvidenceIssuance', str).then(res => {
        //   if (res.status === 'ok') {
        this.verifyForm = row;
        this.verifyVisible = true;
        // } else {
        //   this.$message.error(res.msg || '验证失败');
        // }
      // });
  },
  confirmVerify() {
      this.verifyLoading = true;
      setTimeout(() => {
        this.verifyLoading = false;
        this.verifyForm.verified = true;
        this.$message.success('验证成功');
      }, 1200);
    },
    detailHandle(row) {
      let a = JSON.parse(row.extendInfo);
      this.detailForm = {
        ...row,
        ...a
      };
      this.detailVisible = true;
    },
    evidenceHandle(row) {
      this.fetchCertificateBlob(row).then(blob => {
        this.clearEvidenceBlob();
        this.evidenceBlobUrl = blob;
        this.evidenceImgUrl = URL.createObjectURL(blob);
        this.evidenceImgVisible = true;
      }).catch(e => {
        this.$message.error(e.message || '获取证据出具数据失败');
      });
    },
    //直接下载存证证明PDF（不弹预览）
    downloadCertificate(row) {
      this.fetchCertificateBlob(row).then(blob => {
        const companyName = row.companyName || '';
        const cycle = row.cycle || '';
        let aLink = document.createElement("a")
        aLink.download = `${companyName}-${cycle}-电子数据存证证明.pdf`
        aLink.href = URL.createObjectURL(blob)
        aLink.click()
      }).catch(e => {
        this.$message.error(e.message || '下载失败');
      });
    },
    //调接口获取存证证明并转为PDF Blob
    fetchCertificateBlob(row) {
      let chainId;
      try {
        let a = JSON.parse(row.extendInfo);
        chainId = a.chainId;
      } catch (e) {
        return Promise.reject(new Error('数据格式错误'));
      }
      let d = {
        ids: row.id,
        chainId: chainId,
        proveDataId: ''
      }
      return new Promise((resolve, reject) => {
        xz.ArdCurStat(d, 'ProveApply').then(res => {
          if (res.status !== 'ok') {
            reject(new Error(res.msg || '操作失败'));
            return;
          }
          try {
            let base64 = res.data.okList[0].proves[0].toString();
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], { type: 'application/pdf' })
            resolve(blob);
          } catch (e) {
            reject(new Error('证据出具数据解析失败'));
          }
        }).catch(() => reject(new Error('接口请求失败')));
      });
    },
    //下载证据出具PDF
    downloadEvidencePdf() {
      if (!this.evidenceBlobUrl) return;
      try {
        const row = this.currentRow || {};
        const companyName = row.companyName || '';
        const cycle = row.cycle || '';
        let aLink = document.createElement("a")
        aLink.download = `${companyName}-${cycle}-电子数据存证证明.pdf`
        aLink.href = URL.createObjectURL(this.evidenceBlobUrl)
        aLink.click()
      } catch (e) {
        console.log(e)
        this.$message.error('下载失败');
      }
    },
    //清理blob URL
    clearEvidenceBlob() {
      if (this.evidenceImgUrl) {
        URL.revokeObjectURL(this.evidenceImgUrl);
        this.evidenceImgUrl = '';
      }
      this.evidenceBlobUrl = '';
    }
  }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 16px;
    margin-bottom: 16px;
  }

  .evidence_pagination {
    margin-top: 12px;
    text-align: right;
  }

  .hash_value {
    font-family: Consolas, Monaco, monospace;
    color: #606266;
  }

  .hash_full {
    font-family: Consolas, Monaco, monospace;
    word-break: break-all;
    color: #606266;
  }

  .verify_form .el-form-item,
  .detail_form .el-form-item {
    margin-bottom: 12px;
  }

  .verify_pass {
    color: #67c23a;
    font-weight: bold;
  }

  .verify_fail {
    color: #f56c6c;
    font-weight: bold;
  }

  .evidence_data {
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 10px;
    font-size: 12px;
    max-height: 200px;
    overflow-y: auto;
    width: 460px;
    white-space: pre-wrap;
    word-break: break-all;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .download_raw_btn {
    padding: 0;
    font-size: 13px;
  }

  .download_raw_btn i {
    margin-right: 4px;
  }

  .download_raw_btn.is-disabled,
  .download_raw_btn.is-disabled:hover,
  .download_raw_btn.is-disabled:focus {
    color: #c0c4cc;
  }
</style>

<style>
  .page_evidence .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_evidence .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_evidence .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_evidence .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  /* 合并后的验证弹窗 */
  .page_evidence .verify_result_dialog .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  .page_evidence .verify_result_dialog .el-dialog__header {
    padding: 0;
    margin: 0;
  }

  .page_evidence .verify_result_dialog .el-dialog__headerbtn {
    top: 14px;
    right: 14px;
    z-index: 10;
  }

  .page_evidence .verify_result_dialog .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
  }

  .page_evidence .verify_result_dialog .el-dialog__body {
    padding: 0;
    background: linear-gradient(135deg, #15BA79 0%, #15BA79 100%);
  }

  .page_evidence .verify_result_dialog .verify_result {
    padding: 44px 24px 36px;
    text-align: center;
  }

  .page_evidence .verify_result_dialog .verify_result_head {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
  }

  .page_evidence .verify_result_dialog .verify_icon {
    width: 36px;
    height: 36px;
    background: #ffc107;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
  }

  .page_evidence .verify_result_dialog .verify_icon .el-icon-check {
    color: #fff;
    font-size: 26px;
    font-weight: bold;
  }

  .page_evidence .verify_result_dialog .verify_title {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 1px;
  }

  .page_evidence .verify_result_dialog .verify_actions {
    display: flex;
    justify-content: center;
    gap: 14px;
  }

  .page_evidence .verify_result_dialog .verify_action_btn {
    background: transparent;
    border: 1px solid #fff;
    color: #fff;
    padding: 9px 18px;
    border-radius: 4px;
    font-size: 14px;
  }

  .page_evidence .verify_result_dialog .verify_action_btn:hover,
  .page_evidence .verify_result_dialog .verify_action_btn:focus {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    border-color: #fff;
  }

  .page_evidence .verify_result_dialog .verify_action_btn.is-disabled,
  .page_evidence .verify_result_dialog .verify_action_btn.is-disabled:hover,
  .page_evidence .verify_result_dialog .verify_action_btn.is-disabled:focus {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
    color: rgba(255, 255, 255, 0.65);
  }
</style>